<template>
  <div>
    <div>
      <!-- <el-button
        type="success"
        size="mini"
        icon="el-icon-arrow-left"
        @click="goBack"
        style="background-color: #008a2c; float: left"
        >返回个人中心
      </el-button> -->
      <div @click="goBack" style="cursor: pointer; color: #008a2c">
        <el-button
          type="info"
          style="background-color: #008a2c"
          icon="el-icon-back"
          circle
        ></el-button>
        &nbsp;返回个人中心
      </div>
      <div class="f20 tc">武汉工商学院校历一览表</div>
    </div>
    <el-row>
      <el-col :span="24">
        今天是:<span class="fgreen fb">
          {{ currDateInfo.month }}月{{ currDateInfo.day }}日星期{{
            currDateInfo.weekday
          }}</span
        >
      </el-col>
    </el-row>
    <el-divider></el-divider>
    <el-row :gutter="10">
      <el-col :span="22">
        <el-row :gutter="10">
          <el-col :span="4" v-for="(item, index) in semesterList" :key="item.id"
            ><div
              v-if="index < maxSemesterList"
              class="fb grid"
              :class="
                currSemesterId == item.id ? 'bgLightGreen' : 'bgPurpleLight'
              "
              @click="changeSemesterDate(item.id)"
            >
              {{ item.semesterText }}
            </div></el-col
          >
        </el-row>
      </el-col>
      <el-col :span="2">
        <div
          style="
            line-height: 45px;
            cursor: pointer;
            color: #33b615;
            text-align: right;
          "
          @click="seeMore()"
        >
          <span v-if="seeMoreflg == true">
            收起<i class="el-icon-arrow-up"></i
          ></span>
          <span v-else>更多<i class="el-icon-arrow-down"></i> </span>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="0" class="mt20">
      <el-col :span="3" class="tc fb bggreen fwhite pding10">周次</el-col>
      <el-col :span="3" class="tc fb bggreen fwhite pding10">星期一</el-col>
      <el-col :span="3" class="tc fb bggreen fwhite pding10">星期二</el-col>
      <el-col :span="3" class="tc fb bggreen fwhite pding10">星期三</el-col>
      <el-col :span="3" class="tc fb bggreen fwhite pding10">星期四</el-col>
      <el-col :span="3" class="tc fb bggreen fwhite pding10">星期五</el-col>
      <el-col :span="3" class="tc fb bggreen fwhite pding10">星期六</el-col>
      <el-col :span="3" class="tc fb bggreen fwhite pding10">星期天</el-col>
    </el-row>
    <div style="border-left: 1px solid #ccc; border-bottom: 1px solid #ccc">
      <el-row
        :gutter="0"
        v-for="item in semesterDate"
        :index="item.id"
        :key="item.id"
      >
        <el-col :span="3" class="colBoder fb tc pding10 bgLightGreen">
          {{ item.weekNum }}
        </el-col>
        <el-col
          :span="3"
          v-for="(item2, index2) in item.weekDate"
          :key="item.weekNum + index2"
          class="colBoder fb tc"
        >
          <div
            v-if="item2.indexOf('.') != -1"
            class="pding10"
            style="background-color: #257342"
          >
            <div style="color: white">{{ item2 }}</div>
          </div>
          <div
            v-else-if="item2.indexOf('月') != -1"
            style="background-color: #e9f8df; padding: 8px; margin: 0"
          >
            <div>{{ item2 }}</div>
          </div>
          <div
            v-else
            class="pding10"
            :style="{
              backgroundColor: index2 == 5 || index2 == 6 ? '#FFF6E3' : '',
            }"
          >
            <div>{{ item2 }}</div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { getAllSemesters, getCurrCalendar } from "@/api/schoolCalandar";
export default {
  name: "userCaseList",
  data() {
    return {
      seeMoreflg: false,
      maxSemesterList: 6,
      mylabel: "我的消息",
      activeName: "first",
      jwtoken: "",
      currSemesterId: "",
      semesterList: "",
      currDateInfo: "",
      semesterDate: "",
    };
  },
  mounted() {
    this.jwtoken = this.$route.query.jwtoken;
    this.getSemesterList();
  },
  methods: {
    seeMore() {
      this.seeMoreflg = !this.seeMoreflg;

      if (this.seeMoreflg) {
        this.maxSemesterList = this.semesterList.length;
      } else {
        this.maxSemesterList = 6;
      }
    },
    goBack() {
      this.$router.push("/userCenter");
    },
    //获取学期列表
    async getSemesterList() {
      const res = await getAllSemesters(this.jwtoken);

      this.currSemesterId = res.object.currSemesterId;
      this.semesterList = res.object.semesterList;
      this.getSemesterDate(this.currSemesterId);
    },
    changeSemesterDate(currSemesterId) {
      this.currSemesterId = currSemesterId;
      this.getSemesterDate(currSemesterId);
    },
    //获取当前学期的日历
    async getSemesterDate(currSemesterId) {
      const res = await getCurrCalendar(currSemesterId, this.jwtoken);
      console.log(res);
      if (res.msgCode == "0") {
        console.log(res.object);
        this.currDateInfo = res.object;
        if (this.currDateInfo.remark == null) {
          this.currDateInfo.remark = "本学期暂无备注信息";
        }
        this.semesterDate = res.object.dateList;
      } else {
        this.$refs.uToast.show({
          title: "错误信息：" + res.msg,
          type: "error",
        });
      }
    },
  },
};
</script>
<style>
.bgPurpleLight {
  background: #e5e9f2;
}
.grid {
  text-align: center;
  padding: 10px 5px;
  margin-bottom: 10px;
  cursor: pointer;
}
.colBoder {
  border-right: 1px solid #ccc;
  border-top: 1px solid #ccc;
}
.curWeek {
  background: #bdf384;
}
</style>
